import ApplicationController from './application_controller';
import log from '../lib/logger';

export default class extends ApplicationController {
  static targets = ['sankeyChart'];

  connect() {
    log.info('Revenue Sankey controller connected');

    // Initialize the sankey chart when the controller connects
    if (this.hasSankeyChartTarget) {
      log.info('Sankey chart target found, initializing...');
      this.initializeSankeyChart();
    } else {
      log.info('No sankey chart target found');
    }
  }

  sankeyChartTargetConnected() {
    // This will be called when the sankey chart element is added to the DOM
    log.info('Sankey chart target connected');
    this.initializeSankeyChart();
  }

  initializeSankeyChart() {
    log.info('Initializing sankey chart...');

    // Import and initialize the revenue sankey module
    import('../pages/revenue_sankey')
      .then((module) => {
        log.info('Revenue sankey module loaded');
        const revenueSankey = module.default;
        if (revenueSankey !== undefined) {
          revenueSankey();
        }
      })
      .catch((error) => {
        log.error('Error loading revenue sankey module:', error);
      });
  }

  disconnect() {
    // Clean up when controller disconnects
    if (this.hasSankeyChartTarget) {
      const sankeyElement = this.sankeyChartTarget;
      if (sankeyElement && sankeyElement._resizeHandler) {
        window.removeEventListener('resize', sankeyElement._resizeHandler);
      }
    }
  }
}
